import { render, staticRenderFns } from "./contactRecordList.vue?vue&type=template&id=61ae42a0&scoped=true"
import script from "./contactRecordList.vue?vue&type=script&lang=js"
export * from "./contactRecordList.vue?vue&type=script&lang=js"
import style0 from "./contactRecordList.vue?vue&type=style&index=0&id=61ae42a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ae42a0",
  null
  
)

export default component.exports